<template>
  <div class="cd-section" id="features">
    <!--     *********     FEATURES 3      *********      -->
    <div class="features-3">
      <div class="container">
        <form-wizard
          @on-complete="onComplete"
          title="Creación de una cuenta de Afiliado"
          subtitle="Complete los siguientes datos para poder crear una cuenta de afiliado."
          shape="circle"
          color="#20a0ff"
          error-color="#ff4949"
        >
          <tab-content
            :before-change="beforeSwitchTab1"
            title="Información de la cuenta"
            icon="now-ui-icons design_app"
          >
            <div class="col-md-4 ml-auto mr-auto">
              <el-form :inline="false" :model="form" :rules="rules" ref="ruleForm1">
                <el-form-item label="Número de afiliado" prop="numeroAfiliado">
                  <the-mask
                    mask="######-##"
                    type="tel"
                    v-validate="'length:8'"
                    name="numeroAfiliado"
                    :masked="true"
                    class="form-control"
                    v-model="form.numeroAfiliado"
                    placeholder="000000-00"
                  ></the-mask>
                </el-form-item>
              </el-form>
            </div>
          </tab-content>

          <tab-content
            :before-change="beforeSwitchTab2"
            title="Información de la cuenta"
            icon="now-ui-icons design_app"
          >
            <div class="col-md-4 ml-auto mr-auto">
              <el-form :inline="false" :model="form" :rules="rules" ref="ruleForm2">
                <el-form-item label="Tipo de Documento" prop="tipoDocumento">
                  <el-select style="width:100%" v-model="form.tipoDocumento">
                    <el-option
                      class="option-item"
                      v-for="item in form.tipoDocumentoList"
                      :value="item.TipoDocumentoId"
                      :label="item.TipoDocumentoNombre"
                      :key="item.TipoDocumentoId"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Documento" prop="numeroDocumento">
                  <el-input
                    v-model="form.numeroDocumento"
                    placeholder="Número de documento"
                    class="form-group"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Email" prop="email">
                  <el-input
                    class="form-group"
                    type="email"
                    v-model="form.email"
                    placeholder="Email"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Contraseña" prop="password">
                  <el-input
                    class="form-group"
                    type="password"
                    v-model="form.password"
                    placeholder="Contraseña"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Confirmar contraseña" prop="passwordConfirm">
                  <el-input
                    class="form-group"
                    type="password"
                    v-model="form.passwordConfirm"
                    placeholder="Confirmar contraseña"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </tab-content>

          <!-- :before-change="()=>beforeChangeWithIndex('index')" -->
          <!-- :before-change="beforeChangeOnSteps" -->
          <tab-content
            :before-change="()=>beforeChangeWithIndex(index)"
            title="Pregunta personal"
            icon="now-ui-icons design_app"
            v-for="(item, index) in preguntas"
            :key="item.Pregunta"
          >
            <h3>{{ item.Pregunta }}</h3>
            <div class="col-md-4 ml-auto mr-auto">
              <el-form
                :inline="false"
                :model="form"
                :rules="rulesForSteps"
                :ref="ruleFormStep[index]"
              >
                <el-select
                  class="select-default"
                  placeholder="Seleccione una opción"
                  v-model="form.respuestaElegida[index]"
                >
                  <el-option
                    v-for="x in item.Respuestas"
                    class="option-item"
                    :value="x.RespuestaId"
                    :label="x.Respuesta"
                    :key="x.RespuestaId"
                  ></el-option>
                </el-select>
              </el-form>
            </div>
          </tab-content>

          <el-button type="primary" slot="prev">Anterior</el-button>
          <el-button type="primary" slot="next">Siguiente</el-button>
          <el-button type="primary" slot="finish">Finalizar</el-button>
        </form-wizard>
      </div>
    </div>
    <!--     *********    END FEATURES 3      *********      -->
  </div>
</template>
<script>
//import { Card, Button, FormGroupInput } from "@/components";
import { Card, FormGroupInput } from "@/components";
import { Select, Option, Form, FormItem, Button, Input } from "element-ui";
import * as miscService from "../../services/MiscService";
import * as authService from "../../services/AuthService";
import { TheMask } from "vue-the-mask";

import Vue from "vue";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
Vue.use(VueFormWizard);
import { FormWizard, TabContent } from "vue-form-wizard";
import _ from "lodash";

Vue.use(TheMask);
export default {
  name: "register-page",
  bodyClass: "login-page",
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    FormWizard,
    TabContent,
    TheMask
  },
  data() {
    var self = this;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Ingresa una contraseña"));
      } else {
        if (self.form.passwordConfirm !== "") {
          self.$refs.ruleForm2.validateField("passwordConfirm");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Ingresa la contraseña nuevamente"));
      } else if (value !== self.form.password) {
        callback(new Error("Las contraseñas no coinciden"));
      } else {
        callback();
      }
    };

    return {
      ruleFormStep: [],
      form: {
        email: "",
        numeroDocumento: "",
        tipoDocumento: "",
        tipoDocumentoList: [],
        password: "",
        passwordConfirm: "",
        respuestaElegida: [],
        numeroAfiliado: ""
      },
      afiliadoId: "",
      parentescoId: "",
      rules: {
        numeroDocumento: [
          {
            required: true,
            message: "Debe ingresar un número de documento válido.",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Debe ingresar un email.",
            trigger: "blur"
          },
          {
            type: "email",
            message: "El email debe ser válido.",
            trigger: ["blur", "change"]
          }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwordConfirm: [{ validator: validatePass2, trigger: "blur" }]
      },
      rulesForSteps: {
        respuesta: [
          {
            type: "array",
            required: true,
            message: "Seleccione al menos una respuesta.",
            trigger: "change"
          }
        ]
      },
      preguntas: []
    };
  },
  async mounted() {
    this.form.tipoDocumentoList = await miscService.getAllTipoDocumentos();
    this.form.tipoDocumento = 96; //DNI por defecto
  },
  methods: {
    async onComplete() {
      var self = this;
      var toSend = {
        AfiliadoId: this.afiliadoId,
        ParentescoId: this.parentescoId,
        TipoDocumentoId: this.form.tipoDocumento,
        DocumentoNumero: this.form.numeroDocumento,
        Respuestas: this.form.respuestaElegida,
        Email: this.form.email,
        ConfirmEmail: this.form.email,
        Password: this.form.password,
        ConfirmPassword: this.form.passwordConfirm
      };
      console.log(toSend);

      await this.$osapm()
        .post("Account/RegisterAfiliado", toSend)
        .then(result => {
          self.$noty.success(
            "Se ha creado satisfactoriamente la cuenta de afiliado"
          );
          setTimeout(() => {
            self.$router.push("/login");
          }, 1500);
        })
        .catch(err => {
          var mensaje = _.get(err, "response.data.Message");

          if (mensaje == "UsuarioExiste") {
            self.$noty.error("El usuario ya tiene la cuenta creada");
          } else if(mensaje == "MaxIntentosSuperado"){
            self.$noty.error("Se superó la cantidad de intentos. Comuníquese con su seccional para crear la cuenta");
          } else {
            self.$noty.error(
               "Hubo un error al intentar crear la cuenta del afiliado. Revise las preguntas de seguridad enviadas!"
            );
          }
        });
      //.catch(err => {
      //    self.$noty.error(
      //      "Hubo un error al intentar crear la cuenta del afiliado. Revise las preguntas de seguridad enviadas."
      //    );
      //  });
    },
    beforeSwitchTab1: async function() {
      var self = this;
      var numeroAfiliadoArray = this.form.numeroAfiliado.toString().split("-");

      this.afiliadoId = numeroAfiliadoArray[0];
      this.parentescoId = numeroAfiliadoArray[1];

      var returnPromise = null;

      await this.$osapm()
        .get("Account/GetPreguntasRegistracion", {
          params: {
            afiliadoId: this.afiliadoId,
            parentescoId: this.parentescoId
          }
        })
        .then(result => {
          self.preguntas = result.data;
          returnPromise = new Promise((resolve, reject) => {
            resolve(true);
          });
        })
        .catch(err => {
          var mensaje = _.get(err, "response.data.Message");
      
          if (mensaje == "UsuarioExiste") {
            self.$noty.error("El usuario ya tiene la cuenta creada");
          } else if(mensaje == "MaxIntentosSuperado"){
            self.$noty.error("Se superó la cantidad de intentos. Comuníquese con su seccional para crear la cuenta");
          } else if (mensaje == "AfiliadoInexistente") {
            self.$noty.error("El número de afiliado es incorrecto");
          } else {
            self.$noty.error(
              "Hubo un error al intentar obtener las preguntas de seguridad del afiliado."
            );
          }

          returnPromise = new Promise((resolve, reject) => {
            reject();
          });
        });

      return returnPromise;
    },
    /* Validacion de primer paso */
    beforeSwitchTab2: function() {
      var self = this;
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm2.validate(valid => {
          if (!valid) {
            this.$noty.console.error(
              "Complete los datos solicitados antes de continuar"
            );
          }
          console.log("is valid: " + valid);
          resolve(valid);
        });
      });
    },
    /* Validacion de pasos restantes. Que esté al menos 1 seleccionada */
    beforeChangeWithIndex: function(index) {
      var self = this;
      return new Promise((resolve, reject) => {
        if (self.form.respuestaElegida[index]) {
          resolve(true);
        } else {
          this.$noty.error("Seleccione una respuesta antes de continuar.");
          reject();
        }
      });
    }
  }
};
</script>
<style>
.el-form-item__label {
  padding-bottom: 15px;
  line-height: 0px;
}
.el-input__inner {
  margin-bottom: 10px;
}

.el-form-item__error {
  position: relative;
}

div.input-group >>> .form-group {
  margin-bottom: 0px !important;
}
</style>